import { Box, Button } from '@mui/material';
import { styled } from '@mui/material';

export const HeroSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3, 0),
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 0),
  },
}));

export const StepSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(6, 0),
  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.background.default,
  },
}));

export const StepNumber = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.action.active,
  color: theme.palette.background.paper,
  borderRadius: '50%',
  width: 60,
  height: 60,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '1.5rem',
  fontWeight: 'bold',
  margin: '0 auto 1rem auto',
  [theme.breakpoints.up('md')]: {
    margin: 0,
  },
}));

export const ImageContainer = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  '& img': {
    maxWidth: '100%',
    height: 'auto',
    borderRadius: theme.spacing(1),
    boxShadow: theme.shadows[3],
    border: `2px solid ${theme.palette.action.active}`,
  },
}));

export const HeroStyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  padding: theme.spacing(1, 3),
  fontWeight: 500,
  backgroundColor: theme.palette.action.active,
  color: theme.palette.background.paper,
  '&:hover': {
    backgroundColor: theme.palette.action.active,
    opacity: 0.9,
  },
}));
